import { init as initApm } from '@elastic/apm-rum';
export function useAPM() {
  var _useNuxt2App = useNuxt2App(),
    $config = _useNuxt2App.$config;
  var apm;

  /**
   * Loads Elastic APM.
   * https://www.elastic.co/guide/en/observability/current/apm-rum.html
   *
   * @returns {ApmBase} - Resolves with APM instance.
   */
  function loadAPM() {
    if (process.server) {
      throw new Error('Cannot load APM on server side');
    }
    var serverUrl = $config === null || $config === void 0 ? void 0 : $config.apmServerUrl;
    if (!serverUrl) {
      apm = initApm({
        active: false
      });
      return apm;
    }
    var currentEnv = $config === null || $config === void 0 ? void 0 : $config.apmEnvironment;
    apm = initApm({
      // TODO: Enable APM only for a small percentage of users in production.
      active: Math.random() < (currentEnv === 'prod' ? 0.05 : 0.5),
      serviceName: 'nuxt-front-rum',
      serviceVersion: $config === null || $config === void 0 ? void 0 : $config.version,
      serverUrl: serverUrl,
      environment: currentEnv,
      transactionSampleRate: currentEnv === 'prod' ? 0.1 : 1.0,
      breakdownMetrics: true,
      distributedTracingOrigins: ['http://localhost:3000', /(?:[a-z-]+\.)?aroma-zone\.com/, /(?:[a-z-]+\.)?aroma-host\.net/],
      propagateTracestate: true
    });
    return apm;
  }
  return {
    loadAPM: loadAPM,
    apm: apm
  };
}